import { disablePageScroll, enablePageScroll } from 'scroll-lock'

const filters = () => document.querySelector('[data-filters]')

const openFilters = () => {
    document.body.classList.add('filters--is-open')
    const el = filters()
    if (el) disablePageScroll(el)
}

const closeFilters = () => {
    document.body.classList.remove('filters--is-open')
    const el = filters()
    if (el) enablePageScroll(el)
}

// delegated open/close
document.addEventListener('click', (event) => {
    if (event.target.closest('[data-filters-open]')) openFilters()
    if (event.target.closest('[data-filters-close]')) closeFilters()
})

// re-lock scroll after swaps
document.addEventListener('htmx:afterSwap', (event) => {
    const wasFiltersReplaced = event.target.closest('[data-filters]')
    const filtersAreOpen = document.body.classList.contains('filters--is-open')

    if (wasFiltersReplaced && filtersAreOpen) {
        enablePageScroll(document.body)

        // re-lock fresh filters
        const el = getFilters()
        if (el) disablePageScroll(el)
    }
})
